// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"192":"1d811582","304":"8d1a08e8","626":"33c4b19d"}[chunkId] + ".chunk.css";
};